import BaseService from './base.service';

const baseService = new BaseService('section');

export default {
  findAll: () => baseService.get('findAll'),
};
